module.exports = __webpack_public_path__ + "img/nutrilon-prev-care-home.c315630d.png";